<template>
  <div class="row" style="padding-bottom: 0; margin-bottom: 0;">
    <div class="col m12" style="padding-right: 0;">
      <div class="right chat-container" style="">
        <section id="chat-section" class="module" :class="{expanded: showingDiscussion}">

          <header v-if="showHeader" class="top-bar"
              @click="toggleDiscussion"
              :class="[!showingDiscussion && unreadMessages.length > 0 ? 'unread-message' : '']">

            <div>
              <span>
                <i class="material-icons icon discussion-icon">chat_bubble</i>
              </span>
              <h1>Messages</h1>
            </div>
            <div class="right">
              <span class="right">
                <i-mdi-window-minimize id="chat-minimize" class="icon" width="18" height="18"/>
              </span>
              <div id="unread-messages-badge-div" class="right" style="padding: 0; margin-right: calc(1.2em + 24px); padding-top: 0.2em;">
                <span id="unread-messages-badge" v-show="unreadMessages.length > 0" class="new badge silver">{{unreadMessages.length}}</span>
              </div>
            </div>
          </header>

          <div class="discussion-div basic-flex" v-show="showingDiscussion" style="width: inherit;">
            <discussion ref="discussion" id="text-chat-discussion" @focus="clearUnreadMessages"/>
            <type-box ref="typeBox" :show-button="false" @focus="clearUnreadMessages"/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'text-chat',
  components: {
    discussion: () => import(/* webpackChunkName: "discussion" */ '@C/text-chat/discussion.vue'),
    'type-box': () => import(/* webpackChunkName: "type-box" */ '@C/text-chat/type-box.vue')
  },
  props: {
    showHeader: {
      default: true,
      type: Boolean
    }
  },
  data: function () {
    return {
      wasShowingDiscussion: false // This variable is used for restoring state on fullscreen flows
    }
  },
  computed: {
    ...mapGetters([
      'unreadMessages',
      'showingDiscussion',
      'isFullscreen'
    ])
  },
  watch: {
    isFullscreen (v) {
      if (v) {
        // We've moved to fullscreen..save the last state
        this.wasShowingDiscussion = this.showingDiscussion
      } else {
        this.$store.commit('showingDiscussion', this.wasShowingDiscussion)
      }
    },
    async showingDiscussion (v) {
      if (v) {
        await this.$nextTick()
        const textArea = this.$el.querySelector('textarea')
        textArea.focus()
      }
    }
  },
  methods: {
    ...mapActions([
      'toggleDiscussion',
      'clearUnreadMessages'
    ])
  },
  mounted: function () {
  }
}
</script>

<style lang="scss">
.dark, .theater-mode {
  .chat-container {
    color: $dark-text;
    .top-bar {
      background: $chat-dark-top-bar;
    }
    .discussion-div {
      background: $chat-dark-bg;
      color: $dark-text;
    }
  }
}

.chat-container {
  position: relative;

  .module {
    // border-width: 1px;
    // border-style: solid;
    // border-color: #000;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 340px;
    margin: 20px 0 0 20px;
    z-index: 999;
    @include mobile {
      width: 250px;
    }
  }

  .discussion-icon {
    font-size: 1rem;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  #chat-minimize {
    font-size: 24px;
    line-height: 12px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .discussion-div {
    background-color: var(--background-darken-5);
  }

  .top-bar {
    background: $chat-light-top-bar;
    color: white;
    padding: 0.4rem 0.5rem;
    position: relative;
    overflow: hidden;
    height: 40px;
    cursor: pointer;
    > div {
      display: inline-block;
      height: calc(100%);
    }
    h1 {
      line-height: 24px;
      display: inline;
      font-size: 1rem;
      vertical-align: bottom;
      margin-left: 28px;
    }
    > * {
      position: relative;
    }
  }
}
</style>

<style>
.unread-message::before {
  content: "";
  position: absolute;
  top: -100%;
  left: 0;
  right: 0;
  bottom: -100%;
  opacity: 0.25;
  background: radial-gradient(white, black);
  animation: pulse 1s ease alternate infinite;
}
</style>
